import { BenefitsCardStructure } from 'common/components/benefits-card';
import { WINDOWS_CDN_PATH } from '../../windows-constants';
import { Benefits, FreeProject, Guarantee, ReadyProject } from './components';

export const BENEFITS_CARD_LIST: BenefitsCardStructure<{ elementBlock: string; onBtnClick: () => void; }>[] = [
  {
    elementName: 'Бесплатный замер',
    text: 'Бесплатный замер',
    icon: {
      src: `${WINDOWS_CDN_PATH}/benefits-card/note-icon.png/note-icon.png`,
      alt: 'Бесплатный замер',
    },
    modal: FreeProject,
    name: 'freeProject'
  },
  {
    elementName: '15 лет экспертизы',
    text: '15 лет\nэкспертизы',
    icon: {
      src: `${WINDOWS_CDN_PATH}/benefits-card/benefits-icon.png/benefits-icon.png`,
      alt: '15 лет экспертизы',
    },
    modal: Benefits,
    name: 'benefits'
  },
  {
    elementName: 'Готовые окна точно в срок',
    text: 'Готовые окна точно\nв срок',
    icon: {
      src: `${WINDOWS_CDN_PATH}/benefits-card/pick-up-point-icon.png/pick-up-point-icon.png`,
      alt: 'Готовые окна точно в срок',
    },
    modal: ReadyProject,
    name: 'ready-project'
  },
  {
    elementName: 'Надёжные производители',
    text: 'Надёжные\nпроизводители',
    icon: {
      src: `${WINDOWS_CDN_PATH}/benefits-card/guarantee-icon.png/guarantee-icon.png`,
      alt: 'Надёжные производители',
    },
    modal: Guarantee,
    name: 'guarantee'
  },
];
